/**
 * Pure predicate for whether a submission reviewer/signer has access to every
 * facility on the submission. Shared by the backend CE rule (submissionReviewerSchema)
 * and the Oak client so the two cannot drift.
 *
 * Exemptions mirror the CE rule: staff users and WriteAllFacility users have access
 * to all facilities. Both id lists are filtered of blank/whitespace-only entries;
 * an all-blank or empty submission list means "no access requirement → true".
 */
export function reviewerHasAccessToAllFacilities(args: {
  userFacilityIds: string[];
  submissionFacilityIds: string[];
  isStaff: boolean;
  hasWriteAllFacility: boolean;
}): boolean {
  const { userFacilityIds, submissionFacilityIds, isStaff, hasWriteAllFacility } = args;
  if (isStaff || hasWriteAllFacility) return true;

  const requiredFacilityIds = submissionFacilityIds.filter((id) => id && id.trim() !== "");
  if (requiredFacilityIds.length === 0) return true;

  const accessibleIds = new Set(userFacilityIds.filter((id) => id && id.trim() !== ""));
  return requiredFacilityIds.every((facilityId) => accessibleIds.has(facilityId));
}
